import { useApolloClient, useQuery, useMutation } from "@apollo/client";
import { GET_ORGANIZATION, CREATE_ORGANIZATION_MUTATION, UPDATE_ORGANIZATION_MUTATION } from "../graphQl/OrganismeAPI";

export const useOrganismeData = (organizationId) => {
  const client = useApolloClient();
  const { data, loading, error, refetch } = useQuery(GET_ORGANIZATION, {
    variables: { organizationId },
    skip: !organizationId,
    fetchPolicy: "cache-first",
  });

  const [createMutation, { loading: isCreating }] = useMutation(CREATE_ORGANIZATION_MUTATION);
  const [updateMutation, { loading: isUpdating }] = useMutation(UPDATE_ORGANIZATION_MUTATION);

  // Le statut de l'organisme (MISSING_INFORMATIONS / COMPLETED) est calculé
  // côté serveur et alimente la timeline, les actions requises et le menu.
  // Après une mutation on relit donc l'organisme depuis le serveur : la
  // requête network-only réécrit le cache, et tous les useQuery(GET_ORGANIZATION)
  // montés (menu, gate d'activation, page organisme) se mettent à jour d'un
  // coup — y compris à la création, où cette requête n'existait pas encore
  // dans le cache pour le nouvel identifiant.
  const syncOrganisme = async (id) => {
    if (!id) return;
    try {
      await client.query({
        query: GET_ORGANIZATION,
        variables: { organizationId: id },
        fetchPolicy: "network-only",
      });
    } catch (err) {
      // La mutation a réussi : un échec de relecture ne doit pas la faire
      // passer pour un échec (le cache reste alimenté par la réponse de la
      // mutation, seul le statut recalculé peut alors être en retard).
      console.error("[useOrganismeData] organisation resync failed", err);
    }
  };

  const addOrganisme = async (input) => {
    const res = await createMutation({ variables: { organizationInput: input } });
    const created = res.data?.MT_ADD_ORGANIZATION?.data;
    await syncOrganisme(created?.id);
    return created;
  };

  const updateOrganisme = async (id, input) => {
    const res = await updateMutation({ variables: { organizationId: id, organizationInput: input } });
    await syncOrganisme(id);
    return res.data?.MT_UPDATE_ORGANIZATION?.data;
  };

  return {
    organisme: data?.QR_GET_ORGANIZATION?.data || null,
    loading: loading || isCreating || isUpdating,
    error,
    addOrganisme,
    updateOrganisme,
    refetch
  };
};
